import { BaseRequest } from '@/network/requests/BaseRequest';
import { model_side } from '@/interfaces/model_side';

export const modelSideRequest = BaseRequest.build<model_side>('model_side');